// Lieux et distances — fonctions pures, sans DOM ni navigateur (reprises de ZERO SLANG, src/core/region.js).
import { FRANCE_BOUNDS, LYON, LYON_RADIUS_KM, SANTA_CRUZ, SANTA_CRUZ_RADIUS_KM, USA_BOUNDS } from '../config/constants.js';

const toRad = (d) => (d * Math.PI) / 180;

/** Distance entre deux points (formule de haversine), en km. */
export function distanceKm(a, b) {
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(h));
}

/** Nom du pays dans la langue `lang` depuis son code ISO (« DE » → « Allemagne » / « Germany »). */
export function countryName(code, lang = 'en', fallback = code) {
  try {
    return new Intl.DisplayNames([lang], { type: 'region' }).of(code.toUpperCase()) || fallback;
  } catch {
    return fallback;
  }
}

// Secours hors ligne quand le service de géocodage ne répond pas : on ne reconnaît que les pays et villes de référence
// (France et Lyon, États-Unis contigus et Santa Cruz). Null ailleurs.
const inside = (b, lat, lon) => lat >= b.south && lat <= b.north && lon >= b.west && lon <= b.east;
const OFFLINE = [
  { bounds: FRANCE_BOUNDS, countryCode: 'FR', city: 'Lyon', center: LYON, radius: LYON_RADIUS_KM },
  { bounds: USA_BOUNDS, countryCode: 'US', city: 'Santa Cruz', center: SANTA_CRUZ, radius: SANTA_CRUZ_RADIUS_KM },
];

/** Lieu { countryCode, country, city? } d'une position sans réseau, ou null hors des pays de référence. */
export function offlinePlace(lat, lon, lang = 'en') {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  const zone = OFFLINE.find((z) => inside(z.bounds, lat, lon));
  if (!zone) return null;
  const place = { countryCode: zone.countryCode, country: countryName(zone.countryCode, lang) };
  if (distanceKm({ lat, lon }, zone.center) <= zone.radius) place.city = zone.city;
  return place;
}
